import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { config } from "../../config";
import {
  Menu,
  PrimaryNav,
  NavDropDownButton,
  Title,
  Button,
  Link as USWDSLink,
} from "@trussworks/react-uswds";

import "./SubHeader.scss";
import {getLoginState, logOut} from "../../utils/api/easeyAuthApi";
import Modal from "../Modal/Modal";
import Login from "../Login/Login";
import { getContent } from "../../utils/api/contentApi";

export const SubHeader = ({ user, setCurrentLink }) => {
  let initials = "xx";
  if (user) {
    initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;
  }

  const [userProfileExpanded, setUserProfileExpanded] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState('');
  const [maintenanceContent, setMaintenanceContent] = useState();

  const [userProfileIcon, setUserProfileIcon] = useState(
    "images/icons/menu-item-expand.svg"
  );

  let profileMenuLinkItems = [
    { menu: "Manage Login", link: config.app.cdxBaseUrl },
  ];

  if (config.app.enableManageDelegations !== "false") {
    profileMenuLinkItems.push({
      menu: "Manage Delegations",
      link: `${config.app.cbsBaseUrl}${config.app.cbsManageDelegationsPath}`,
    });
  }

  const userProfileMenuLinks = {
    label: <span className="margin-right-1 text-no-wrap">User Profile</span>,
    items: profileMenuLinkItems,
  };

  const subHeaderMenuList = [
    {
      label: <span className="margin-right-1 text-no-wrap font-body-sm">Resources</span>,
      items: [
        { menu: "FAQs", link: `/faqs` },
        { menu: "Resources", link: `/resources` },
      ],
      title: "resources",
    },
    {
      label: (
        <span className="margin-right-1 text-no-wrap font-body-sm">
          <span
            className="margin-right-2 menu-item-separator display-none desktop-lg:display-inline-block"
            style={{ color: "#365b8f" }}
          >
            |
          </span>
          Help/Support
        </span>
      ),
      link: "/help-support",
      items: [],
      title: "help-support",
    },
    // {
    //   label: (
    //     <span className="margin-right-1 text-no-wrap">
    //       <span className="margin-right-20 menu-item-separator">|</span>Site Map
    //     </span>
    //   ),
    //   items: [],
    // },
  ];

  //Determines login state and disables login if system is down.
  useEffect(() => {
    getLoginState()
      .then((response) => {
        setApplicationStatus(response.data.status);
      })
      .catch(err => {
        if(err.response.status === 503){
          setApplicationStatus("DOWN");
        }
      });
  }, []);

  useEffect(() => {
    if(applicationStatus && applicationStatus === "DOWN"){
      getContent("/ecmps/login/maintenance.md").then((resp) => {
        setMaintenanceContent(resp.data);
      });
    }
    
  }, [applicationStatus]);

  useEffect(() => {
    setCategorySelected([false, false, false, false, false]);
  }, []);

  const [navDropdownOpen, setNavDropdownOpen] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [categorySelected, setCategorySelected] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const handleToggleNavDropdown = (column) => {
    if (userProfileExpanded === true) {
      toggleUserProfileDropdown();
    }
    setNavDropdownOpen((prevNavDropdownOpen) => {
      const newOpenState = Array(prevNavDropdownOpen.length).fill(false);
      newOpenState[column] = !prevNavDropdownOpen[column];
      return newOpenState;
    });
  };

  const handleSubMenuClick = (column) => {
    setCurrentLink(false);
    handleToggleNavDropdown(column);

    setCategorySelected([false, false, false, false, false]);
  };

  const toggleUserProfileDropdown = () => {
    if (userProfileExpanded === true) {
      document.querySelector("#logoutBtn").tabIndex = 0;
      setUserProfileIcon(
        "images/icons/menu-item-expand.svg"
      );
    } else {
      document.querySelector("#logoutBtn").tabIndex = -1;
      setUserProfileIcon(
        "images/icons/menu-item-collapse.svg"
      );
      setNavDropdownOpen((prevNavDropdownOpen) => {
        return Array(prevNavDropdownOpen.length).fill(false);
      });
    }

    setUserProfileExpanded(!userProfileExpanded);
  };

  const [show, setShow] = useState(false);

  const closeModalHandler = () => {
    setShow(false);
  };

  const openModal = (value) => {
    setShow(value);
  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <div className="subheader-wrapper bg-primary-dark ">
      <div className={`usa-overlay ${show ? "is-visible" : ""}`} />
      <div className="padding-y-2 mobile-lg:padding-x-1 desktop:padding-x-4">
        <div className="usa-nav-container subheader-wrapper-container padding-x-0 desktop-lg:margin-top-3">
          <div className="subheader-title">
            <Title className="margin-1 margin-top-0 desktop:margin-top-1 desktop-lg:margin-top-0">
              <h1 className="display-inline-block text-white text-bold desktop-lg:font-sans-2xl desktop:font-sans-2xl mobile-lg:font-sans-xl margin-0">
                ECMPS
              </h1>
              <span className="display-none desktop-lg:display-inline-block desktop-lg:margin-left-1 text-white text-normal font-sans-sm width-card-lg text-wrap">
                Emissions Collection and Monitoring Plan System
              </span>
            </Title>
          </div>


          <div className="subheader-nav">
            <PrimaryNav
              className="float-left desktop:margin-top-1 desktop-lg:margin-top-0"
              mobileExpanded={isMobileMenuOpen}
              onToggleMobileNav={()=>setIsMobileMenuOpen(false)}
              items={subHeaderMenuList.map((el, i) => {
                if (el.items.length === 0) {
                  return (
                    <>
                      <Link
                        to={el.link ?? config.app.path}
                        target="_blank"
                        title={el.title}
                        aria-label={el.title}
                        onClick={() => handleSubMenuClick(i)}
                      >
                        {el.label}
                      </Link>
                      {categorySelected[i] === true ? (
                        <div className="menu-underline" />
                      ) : null}
                    </>
                  );
                } else {
                  return (
                    <>
                      <NavDropDownButton
                        key={i}
                        label={el.label}
                        menuId={`menu-${el.title}`}
                        isOpen={navDropdownOpen[i]}
                        onToggle={() => {
                          handleToggleNavDropdown(i);
                        }}
                      />
                      <Menu
                        id={
                          i === subHeaderMenuList.length - 1
                            ? `extended-nav-section-last`
                            : null
                        }
                        className="font-body-sm"
                        items={el.items.map((item) =>
                          item.tab ? (
                            <USWDSLink
                              href={item.link}
                              rel={item.link}
                              target="_blank"
                            >
                              {item.menu}
                            </USWDSLink>
                          ) : (
                            <Link to={item.link} target="_blank">{item.menu}</Link>
                          )
                        )}
                        isOpen={navDropdownOpen[i]}
                      />
                      {categorySelected[i] === true ? (
                        <div className="menu-underline" />
                      ) : null}
                    </>
                  );
                }
              })}
            />
            <div className="display-flex flex-justify-center">
              {user ? (
                <>
                  <span
                    data-testid="loggedInUserInitials"
                    data-initials={initials}
                    className="display-flex flex-align-center position-relative text-bold float-right clearfix cursor-pointer mobile:margin-top-1 desktop:margin-top-1 desktop:margin-top-2 desktop-lg:margin-top-0 margin-left-2"
                    id="loggedInUserInitials"
                    aria-expanded="false"
                  >
                    <img
                      id="toggleDropDown"
                      src={userProfileIcon}
                      className="margin-top-neg-1 left-neg-1"
                      tabIndex="0"
                      alt="Expand menu"
                      onClick={() => toggleUserProfileDropdown()}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          toggleUserProfileDropdown();
                        }
                      }}
                    />
                    {userProfileExpanded ? (
                      <span className="top-neg-2" >
                        <Menu
                          className="font-body-sm position-absolute"
                          style={{ fontWeight: "normal" }}
                          items={userProfileMenuLinks.items.map((item) => (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.menu}
                            </a>
                          ))}
                          isOpen={true}
                        />
                      </span>
                    ) : null}
                    <span className="text-bold text-white text-no-wrap left-neg-2 top-neg-2">
                      Welcome, {user.firstName}!
                    </span>
                    <span className="text-bold text-white text-no-wrap clearfix top-neg-2 margin-x-2">
                      <Button
                        type="button"
                        id="logoutBtn"
                        epa-testid="logoutBtn"
                        outline={true}
                        onClick={() => logOut()}
                        title="Click this button to logout"
                        className="text-white border-white text-no-wrap"
                      >
                        Log Out
                      </Button>
                    </span>
                    
                  </span>
                </>
              ) : (
                <span className="text-bold text-white text-no-wrap clearfix desktop:margin-x-2">
                  <Button
                    type="button"
                    outline={true}
                    id="openModalBTN"
                    epa-testid="openModalBTN"
                    onClick={() => {
                      window.openModalBtn = document.activeElement;
                      openModal(true);
                    }}
                    className="text-white border-white text-no-wrap"
                  >
                    Log In
                  </Button>
                  {show ? (
                    <Modal
                      show={show}
                      close={closeModalHandler}
                      returnFocus={true}
                      children={<Login isModal={true} maintenanceContent={maintenanceContent} closeModalHandler={closeModalHandler} />}
                    />
                  ) : null}
                </span>
              )}
              <Button
                id="btnMobileMenu"
                type="button"
                className="bg-transparent margin-0 desktop:display-none padding-0 width-auto margin-top-1 margin-right-2"
                onClick={() => setIsMobileMenuOpen(true)}
                style={{ order: 1 }}
                aria-label="Expand top navigation menu"
              >
                <img
                  src={"images/icons/mobile-menu-expand.svg"}
                  alt="Expand top navigation menu"
                />
              </Button>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};
